<template>
    <div class="w3-margin">   
        <div v-if="route" style="max-width:640px; margin:0 auto">            
            <div class=" w3-center">
                <div v-on:click="goBackAllRoute()" class="cursorpointer w3-text-blue">
                    Vissza az útvonalakhoz
                </div>                                    
                <div class="w3-margin w3-xlarge route-title"><b>{{route.name}}</b></div>
                <div v-on:click="routePlaning()" class="w3-margin-bottom cursorpointer w3-text-blue">
                    Útvonaltervezés a rajthoz
                </div>
                <div v-on:click="showCertifyList()" v-if="isOnline" class="cursorpointer w3-text-green w3-margin-bottom w3-hover-text-blue" >
                    <font-awesome-icon icon="hiking"></font-awesome-icon> TELJESÍTÉSEK
                </div>        
                <Entry v-bind:route="route"></Entry>
            </div>                    
            <div class="w3-margin-top w3-large route-title"><b>Leírás</b></div>
            <div class="w3-justify w3-margin-bottom"  v-html="$nl2br(route.description)"></div>             
            <div>
                <div class="w3-margin-top w3-large route-title"><b>Alapadatok</b></div>                
                <table class="w3-table-all w3-small" >
                    <tr>
                        <td>Ár</td>
                        <td><font-awesome-icon icon="dollar-sign"></font-awesome-icon> {{route.price}} {{$appData.currency}}</td>
                    </tr>                        
                    <tr>
                        <td>Tájegység / Járás</td>
                        <td><font-awesome-icon icon="map-marked-alt"></font-awesome-icon> 
                        {{route.landscape | filterLandscapeToString}} / {{route.district}}</td>
                    </tr>                        
                    <tr>
                        <td>Táv</td>
                        <td><font-awesome-icon icon="route" ></font-awesome-icon> {{route.distance}} km</td>
                    </tr>
                    <tr>
                        <td>Szintemelkedés</td>
                        <td><font-awesome-icon icon="angle-up" ></font-awesome-icon> {{route.level}} m</td>
                    </tr>
                    <tr>
                        <td>Teljesítési mód</td>
                        <td>
                            <span v-if="route.mode==1"><font-awesome-icon icon="hiking" ></font-awesome-icon> Gyalogos, Futó</span>
                            <span v-if="route.mode==2"><font-awesome-icon icon="bicycle" ></font-awesome-icon> Kerékpáros</span>
                        </td>
                    </tr>                        
                    <tr>
                        <td>Szintidő</td>
                        <td>                            
                            <span v-if="route.mode==1">
                                <font-awesome-icon icon="hourglass-half" ></font-awesome-icon> <font-awesome-icon icon="running" ></font-awesome-icon> {{route.timeRun}}h | 
                                <font-awesome-icon icon="hourglass-half" ></font-awesome-icon> <font-awesome-icon icon="hiking" ></font-awesome-icon> {{route.timeHike}}h | 
                                <font-awesome-icon icon="hourglass-half" ></font-awesome-icon> <font-awesome-icon icon="walking" ></font-awesome-icon> {{route.timeTour}}h
                            </span>
                            <span v-else>
                                <font-awesome-icon icon="hourglass-half" ></font-awesome-icon> <font-awesome-icon icon="bicycle" ></font-awesome-icon> {{route.timeBike}}h
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>Pontszám</td>
                        <td><font-awesome-icon icon="flag-checkered" ></font-awesome-icon> {{route.ggpoint}}</td>
                    </tr>
                    <tr>
                        <td>Díjazás</td>
                        <td><font-awesome-icon icon="award"></font-awesome-icon> {{route.prise | filterPriseToString}}</td>
                    </tr>                        
                    <tr>
                        <td>Szervező neve</td>
                        <td><font-awesome-icon icon="user"></font-awesome-icon> {{route.contactname}}</td>
                    </tr>
                    <tr>
                        <td>Telefonszám</td>
                        <td><font-awesome-icon icon="phone"></font-awesome-icon> {{route.contactphone}}</td>
                    </tr>
                    <tr>
                        <td>E-mail</td>
                        <td><font-awesome-icon icon="envelope"></font-awesome-icon><a class="w3-text-blue link" :href="'mailto:'+route.contactemail"> {{route.contactemail}}</a></td>
                    </tr>
                    <tr>
                        <td>Web</td>
                        <td><font-awesome-icon icon="globe"></font-awesome-icon><a class="w3-text-blue link" :href="route.web" target="_blank"> {{route.web}}</a></td>
                    </tr>
                </table> 
            </div>   

            <div class="w3-center w3-margin-top w3-margin-bottom">        
                <img :src="route.imgUrl"  class="responsive-img w3-card-2 w3-margin-bottom">
                <div class="w3-margin-bottom">
                    <div v-if="route.videoUrl" class="w3-hide-small">
                        <iframe style="max-width:640px;" width="100%" height="480" :src="route.videoUrl" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                    <div v-if="route.videoUrl" class="w3-hide-medium w3-hide-large">
                        <iframe style="max-width:600px;" width="100%" height="315" :src="route.videoUrl" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </div>
                <div class="w3-margin-bottom">                
                    <div v-if="route.galleryUrl" class="w3-hide-small">
                        <iframe style="max-width:640px;" width="100%" height="480" :src="route.galleryUrl" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                    <div v-if="route.galleryUrl" class="w3-hide-medium w3-hide-large">
                        <iframe style="max-width:600px;" width="100%" height="315" :src="route.galleryUrl" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </div>
            </div>                    


            <div class="w3-margin-top w3-large route-title"><b>Ellenőrzőpontok</b></div>
            <table v-if="points" class="w3-table-all w3-small">
                <tr class="theme-1">
                    <td>#</td>
                    <td>Ellenőrzőpont</td>
                    <td class="w3-center">Rész táv</td>
                    <td class="w3-center">Rész szint</td>                        
                    <td class="w3-center w3-hide-small">Össz táv</td>
                    <td class="w3-center w3-hide-small">Össz szint</td>                        
                </tr>
                    <tr v-for="(item, index) in orderedPointsList" :key="index">                            
                        <td>{{index+1}}.</td>                    
                        <td>
                            <span v-if="item.description || item.imgUrl" v-on:click="showPointInfo(item)" class="w3-text-green w3-hover-text-blue cursorpointer">
                                {{item.name}}
                                <font-awesome-icon icon="info-circle" ></font-awesome-icon>
                            </span>
                            <span v-else>{{item.name}}</span>
                        </td>
                        <td class="w3-center"><span v-if="item.prevDist || item.prevDist=='0'">{{item.prevDist | filterFloatRound}} km</span></td>
                        <td class="w3-center"><span v-if="item.prevLevel || item.prevLevel=='0'">{{item.prevLevel}} m</span></td>                        
                        <td class="w3-center w3-hide-small"><span v-if="item.sumDist || item.sumDist=='0'">{{item.sumDist | filterFloatRound}} km</span></td>
                        <td class="w3-center w3-hide-small"><span v-if="item.sumLevel || item.sumLevel=='0'">{{item.sumLevel}} m</span></td>                                                    
                    </tr>                    
            </table>  
            <div class="w3-center">
                <div v-on:click="showMap()" v-if="isOnline" class="w3-margin w3-button w3-border w3-border-green w3-green w3-hover-white" >
                    <font-awesome-icon icon="map-marked-alt"></font-awesome-icon> TÉRKÉP
                </div>        
            </div>
            <!--
            <div class="w3-card-2 w3-margin-top">
                <Map v-if="track && markers" :track="track" :markers="markers"></Map>
            </div>
            -->

            <div class="w3-margin-top w3-large route-title"><b>Letölthető dokumentumok</b></div>
            <div v-on:click="openDoc(route.trackUrl)" class="cursorpointer w3-padding w3-text-green w3-hover-text-blue">Track [.gpx]</div>            
            <div class=""  v-for="(item, index) in route.documents" :key="index" >
                <div v-on:click="openDoc(item.url)" class="cursorpointer w3-padding w3-text-green w3-hover-text-blue">{{item.name}} [.{{item.type}}]</div>
            </div>  

            <div v-if="isOnline">
                <div class="w3-margin-top w3-large route-title"><b>Kommentek</b></div>
                <div class="" v-if="isWriteComment">
                    <!--<label class="w3-text-blue">Új komment</label>-->
                    <textarea id="commentTextArea" v-model="commentTxt" rows="6" class="w3-input w3-border w3-margin-top w3-margin-bottom"></textarea>   
                    <div v-on:click="saveComment()" class="w3-right w3-margin-bottom w3-button w3-padding w3-green w3-border w3-border-green w3-hover-white">Hozzászólás mentése</div>                               
                </div>
                
                <div v-if="commentList" class="w3-clear">
                    <div v-for="(item, index) in commentList" :key="index">
                        <div v-if="(item.creatuser==userId )|| item.status==2" class="w3-margin-top w3-border">
                            <div class="w3-padding w3-light-grey">
                                <span v-if="item.creatuser==userId">
                                    <span v-if="item.status==1" title="A hozzászólás még nincs moderálva.">
                                        <font-awesome-icon icon="exclamation-circle" class="w3-text-yellow"></font-awesome-icon>  
                                    </span>
                                    <span v-if="item.status==2" title="A hozzászólás engedélyezve.">
                                        <font-awesome-icon icon="check-circle" class="w3-text-green"></font-awesome-icon>  
                                    </span>
                                    <span v-if="item.status==3" title="A hozzászólás le lett tíltva.">
                                        <font-awesome-icon icon="times-circle" class="w3-text-red"></font-awesome-icon>  
                                    </span>
                                </span>
                                {{item.userName}}
                                <span v-if="item.creatuser==userId" class="w3-right">
                                    &nbsp;&nbsp;
                                    <span v-on:click="deleteCommentConfirm(item)" class="cursorpointer w3-text-red w3-right" title="Hozzászólás törlése"><font-awesome-icon icon="trash-alt"></font-awesome-icon></span>
                                    <span v-on:click="editComment(item)" class="cursorpointer w3-text-green w3-right" title="Hozzászólás szerkesztése"><font-awesome-icon icon="edit"></font-awesome-icon>&nbsp;</span>                        
                                </span>
                                <span class="w3-right"><i>{{item.creatdate | filterDateTimeFormat}}</i></span>

                            </div>
                            <div class="w3-justify w3-padding" v-html="$nl2br(item.comment)"></div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div v-if="isPointInfo" class="w3-modal" style="z-index: 4000; display:block;">    
            <div class="w3-modal-content w3-card-4 w3-animate-zoom w3-border">
                <span class="w3-button w3-right w3-text-red w3-hover-red" v-on:click="isPointInfo=false">
                    <font-awesome-icon icon="times"></font-awesome-icon>
                </span>             
                <div class="w3-container w3-white">                 
                    <p class="route-title">{{aktPoint.name}}</p>
                    <img v-if="aktPoint.imgUrl" :src="aktPoint.imgUrl" style="width:100%" class="w3-card-2">                    
                    <p v-if="aktPoint.description" class="w3-justify" v-html="$nl2br(aktPoint.description)"></p>
                </div>             
                <br>
            </div>
        </div>    


    </div>
</template>

<script>
const fb = require('../firebase.js');
import Map from '../components/Map.vue';
import Entry from '../components/Entry.vue';
//import '../plugins/flickr/client-code.js'
export default {
    name: 'RouteInfo', 
    data() {
        return {
            isWriteComment:false,
            userId:0,
            commentTxt:'',
            editCommentId:null,
            commentList:null,
            route:null,
            track:null,
            points:null,
            markers:null,
            isPointInfo:false,
            aktPoint:null
        }
    },     
    components: {
      Map,
      Entry
    },
    computed: {
        orderedPointsList: function () {
            var orderedList=_.orderBy(this.points, 'ordernum', 'asc');
            return this.addSubSum(orderedList);            
        }
    },  
    methods:{
        editComment(item){
            this.commentTxt=item.comment;
            this.editCommentId=item.id;
            document.getElementById("commentTextArea").focus();
        },
        deleteCommentConfirm(item){
            let self = this;
            self.$dialog.confirm(this.$setDialogMsg("w3-yellow","Törlés","Biztosan törlöd a hozzászólást?"))
            .then(function(dialog) {
                self.$showSpinner();
                fb.DeleteComment(item.id).then(res=>{
                    var newList=[]
                    for (var i in self.commentList) {
                        if (self.commentList[i].id!=item.id) {
                            newList.push(self.commentList[i]);
                        }
                    }
                    self.commentList=newList;
                    self.$hideSpinner();
                    self.$dialog.alert(self.$setDialogMsg('w3-green','Törlés',"A hozzászólás törlése megtörtént."));                 
                }).catch(e=>{        
                    self.$hideSpinner();
                    self.$dialog.alert(self.$setDialogMsg('w3-red','Hibaüzenet',"Hiba történt a művelet során"));                 
                })
            });
        },
        saveComment(){
            if (this.$store.getters.userProfile.publicName) {
                this.$showSpinner();
                var newComment={
                    "creatuser":this.$store.getters.userProfile.uid,
                    "userName":this.$store.getters.userProfile.publicName,
                    "hikeId":this.route.id,
                    "hikeName":this.route.name,
                    "status":1,
                    "creatdate":new Date().getTime(),
                    "comment":this.commentTxt,
                    "id":this.editCommentId
                }
                var newItem=(newComment.id==null);
                fb.UpdateComment(newComment).then(res=>{
                    this.$hideSpinner();
                    this.$dialog.alert(this.$setDialogMsg('w3-green','Mentés',"A hozzászólás mentése megtörtént."));  
                    if (newItem) {
                        this.commentList.push(res);  
                    } else {
                        for (var i in this.commentList) {
                            if (this.commentList[i].id==this.editCommentId) this.commentList[i]=res;
                        }
                    }
                    this.commentList=_.orderBy(this.commentList, ['creatdate'], ['desc']); 
                    this.commentTxt=''; 
                    this.editCommentId=null;        
                }).catch(e=>{  
                    console.log(e);      
                    this.$hideSpinner();
                    this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet',"Hiba történt a művelet során"));                 
                })
            } else {
                    this.$dialog.alert(this.$setDialogMsg('w3-amber','Figyelmeztetés',"Hozzászólás írása előtt töltse ki adatlapján a 'Publikus név' mezőt!"));                               
            }
        },
        routePlaning(){
            var url='https://www.google.com/maps/dir//'+this.route.lon+','+this.route.lat+'/@'+this.route.lon+','+this.route.lat+',12z';
            window.open(url, '_blank');
        },
        showPointInfo(item){
            this.isPointInfo=true;
            this.aktPoint=item;
        },
        openDoc(url){
            window.open(url, '_blank');
        },
        showMap(){
            this.$storage.set('actualTrack', this.track);
            this.$router.push({ name: 'mainmap', params: { source: 'oneRoute', markers:this.markers }});            
        },
        showCertifyList(){
            this.$router.push({name:'certifylist', params: { routeId: this.route.id } });                            
        },
        goBackAllRoute() {
            this.$router.push('/routes');
        },
        addSubSum(plist){
            var sumDist=0;
            var sumLevel=0;
            for (var i in plist){
                sumDist+=plist[i].prevDist;
                sumLevel+=plist[i].prevLevel;
                plist[i].sumDist=sumDist;
                plist[i].sumLevel=sumLevel;
            }
            return plist;
        },
    },           
    mounted() {
        this.$showSpinner();
        if (this.$store.getters.userProfile) this.userId=this.$store.getters.userProfile.uid;
        fb.GetGeogo(this.$route.params.routeId).then(res=>{
            this.route = res;
            fb.GetCommentsByRouteId(this.route.id).then(res=>{
                this.commentList=res;
                this.commentList=_.orderBy(this.commentList, ['creatdate'], ['desc']);   
            }).catch(e=>{
                console.log(e);
                //this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt a hozzászólások betöltése során.'));
            });
            if (this.userId!=0) {
                fb.GetFavoriteList(this.userId).then(res=>{
                    for (var r in res) {
                        if ((this.route.id==res[r].hikeId) && (res[r].status>1)) this.isWriteComment=true;
                    }
                }).catch(e=>{
                    console.log(e);
                });
            }
            fb.GetPoints(this.route.id).then(res=>{
                this.points=res.points;
                this.markers=res.markers;
                if (this.route.trackUrl) {
                    fb.GetTrack2(this.route.trackUrl).then(res=>{
                        this.track=res;
                        this.$hideSpinner();
                    }).catch(e=>{                    
                        console.log(e);                        
                        this.$hideSpinner();
                        this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt a track letöltése során.'));
                    })                 
                } else {
                    this.$hideSpinner();
                }            
            }).catch(e=>{
                console.log(e);                
                this.$hideSpinner();
                this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt a pontadatok letöltése során.'));
            });                 
        }).catch(e=>{
            console.log(e);
            this.$hideSpinner();
            this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt az adatok betöltése során.'));
        }); 
        
        
    },
}
</script>

    